<template>
  <div class="logo-bg">
    <div class="sign-cont">
      <img src="@/assets/img/base/logo.png" class="sign-logo" alt="">
      <div class="sign-form">
        <div class="sign-title"><div class="iconfont icon-fanhui2" @click="reBack"></div>完善资料，即可完成注册</div>
        <div class="upload-img">
          <div class="nick">
            <img v-if="selfOpt.head_pic" class="nick-img" :src="selfOpt.head_pic" alt="">
            <img v-else class="nick-img" src="@/assets/img/login/nick.png" alt="">
            <input type="file" accept="image/*" :multiple="false" @change="handleImgUpload" />
            <img v-if="selfOpt.head_pic" class="nick-camera" src="@/assets/img/login/camera.png" alt="">
          </div>
          <div class="nick-info">上传真实的照片，方便导师找到你</div>
        </div>
        <div class="input-label">姓名 <span class="require">*</span></div>
        <div class="input-line" :data-attr="toastInfo.real_name">
          <input v-model="selfOpt.real_name" placeholder="请输入姓名" type="text" @input="inputChange($event,'real_name')">
        </div>
        <div class="input-label">机构信息 <span class="require">*</span></div>
        <div class="input-line" :data-attr="toastInfo.organization">
          <input v-model="selfOpt.organization" placeholder="请输入机构名称" type="text" @input="inputChange($event,'organization')">
        </div>
        <div class="input-line">
          <el-cascader placeholder="请选择所在区域" v-model="orgArea" :options="areaData" @change="handleAreaChange"></el-cascader>
        </div>
        <div class="input-label">邀请码</div>
        <div class="input-line">
          <input v-model="selfOpt.invite_code" placeholder="请输入输入业务员编码" type="text">
        </div>
        <div class="input-label">个人简介</div>
        <textarea class="input-textarea" v-model="selfOpt.introduction" placeholder="请输入个人简介"></textarea>
        <div class="submit-btn black-14" @click="submitForm" :class="isRight ? '' : 'dis-bg'">完成注册</div>

      </div>
    </div>
  </div>
</template>

<script>
import {GetArea, LoginByPassword, Logout, UpdateSelf} from "@/http/api";
import { user_info } from "@/http/user_center";
import ossUpload from "@/http/ossUpload";

export default {
  name: "index",
  data() {
    return {
      selfOpt: {
        real_name: "",
        organization: "",
        province: "",
        city: "",
        district: null,
        introduction: null,
        invite_code: null,
        head_pic: null,
      },
      toastInfo: {
        real_name: "",
        organization: "",
      },
      isRight: false,
      areaData: [],
      orgArea: [],
    };
  },
  beforeCreate() {
    user_info().then((res) => {
      if (res.code == 200) {
        if (res.data.is_perfect == 1) {
          localStorage.setItem("member", JSON.stringify(res.data));
          this.$store.commit("memberChange", res.data);
          this.$router.push("/home");
        }
      }
    });
  },
  mounted() {
    GetArea({ level: 2 }).then((res) => {
      this.areaData = res.data;
    });
  },
  methods: {
    submitForm() {
      this.selfOpt.province = this.orgArea[0];
      this.selfOpt.city = this.orgArea[1];
      this.selfOpt.district = this.orgArea[2];
      UpdateSelf(this.selfOpt).then((res) => {
        if (res.code == 200) {
          localStorage.setItem("member", JSON.stringify(res.data));
          this.$store.commit("memberChange", res.data);
          this.$router.push("/home");
        } else {
          this.$message.error(res.message[0]);
        }
      });
    },
    handleAreaChange(val) {
      this.orgArea = val;
      if (
        this.toastInfo.real_name == "" &&
        this.toastInfo.organization == "" &&
        this.orgArea.length
      )
        this.isRight = true;
      else this.isRight = false;
    },
    handleImgUpload(e) {
      ossUpload.bucketUpload(
        e.target.files[0],
        (res) => {
          this.selfOpt.head_pic = res.url;
        },
        (err) => {
          this.$message({
            type: "error",
            message: "上传失败",
          });
        },
        "duole-images",
        "/upload/image/pc/"
      );
    },
    inputChange(e, type) {
      if (type == "real_name") {
        if (this.selfOpt.real_name.trim() != "") this.toastInfo.real_name = "";
        else this.toastInfo.real_name = "请输入姓名";
      } else {
        if (this.selfOpt.organization.trim() != "")
          this.toastInfo.organization = "";
        else this.toastInfo.organization = "请输入机构名称";
      }
      if (
        this.toastInfo.real_name == "" &&
        this.toastInfo.organization == "" &&
        this.orgArea.length
      )
        this.isRight = true;
      else this.isRight = false;
    },
    openDialog(type) {
      this.showDialog = true;
      this.showDialogType = type;
    },
    reBack(){
      localStorage.setItem('token',false)
      localStorage.setItem('member',false)
      Logout().then(() => {
        localStorage.setItem('member', '')
        localStorage.setItem('token','')
        window.location.href = "/login";
      }).catch(()=>{
        localStorage.setItem('member', '')
        localStorage.setItem('token','')
        window.location.href = "/login";
      });
    }
  },
};
</script>

<style scoped src="../../assets/css/login.css"></style>

<style>
.input-line::after {
  content: attr(data-attr);
  color: #fed400;
  font-size: 12px;
  position: relative;
  top: -5px;
}
.input-line input {
  padding: 0 15px;
  width: 346px;
  height: 42px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  color: #333333;
}
.input-line input:focus {
  border: 1px solid #fed400 !important;
  box-shadow: 0px 0px 2px 2px rgba(254, 212, 0, 0.2);
}
</style>
